<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">

                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Bem-vindo, {{ $page.props.user.name }}
                </h2>
            </div>
        </template>
        <div class="py-12 pt-12 pb-6">
            <flash :timeout="5000"/>
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <iframe :src="dash_url"
                            class="flex"
                            style="width: 100%"
                            height="800" ></iframe>
                </div>
            </div>
        </div>

    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout'
import Welcome from './../../Jetstream/Welcome'
import ptBR from 'vuejs-datepicker/dist/locale'
import Button from "../../Jetstream/Button";
import Balance from "../../Helpers/Balance";
import Flash from "../../Helpers/Flash";

export default {
    components: {
        Flash,
        Balance,
        Button,
        AppLayout,
        Welcome,
    },
    props: ['dash_url'],
    data() {
        return {
            ptBR: ptBR
        }
    },
    methods: {

    }
}
</script>
